import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";

import { LanguageContext } from "../utils/contexts";
import { localize } from "../utils/translator";

import { makeStyles } from "@material-ui/core/styles";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Button,
  CssBaseline,
  Divider,
  Drawer,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  Slider,
  Toolbar,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExploreIcon from "@material-ui/icons/Explore";
import EuroIcon from "@material-ui/icons/Euro";
import FolderSpecialIcon from "@material-ui/icons/FolderSpecial";
import PeopleIcon from "@material-ui/icons/People";
import SchoolIcon from "@material-ui/icons/School";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import TranslateIcon from "@material-ui/icons/Translate";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";

import CenteredContent from "../components/CenteredContent";
import CustomTextField from "../components/CustomTextField";

import { useHistory } from "react-router-dom";

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    paddingTop: 50,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    zIndex: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#f6f6f6",
  },
  drawerContainer: {
    overflow: "auto",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  accordionRoot: {
    width: "100%",
  },
  heading: {
    fontWeight: theme.typography.fontWeightRegular,
  },
  inline: {
    display: "inline",
  },
  compareHeader: {
    position: "fixed",
    backgroundColor: "#ffc26c",
    width: "100%",
    height: 50,
    top: 70,
    left: 0,
    justifyContent: "center",
    alignItems: "center",
  },
  compareText: {
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: "bold",
    left: "40%",
    top: "25%",
    color: "#504538",
  },
  runCompareButton: {
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    left: "90%",
    top: "17%",
    color: "#504538",
  },
  compareButton: {
    position: "absolute",
    left: "85%",
  },
}));

function valuetext(value) {
  return `${value}°C`;
}

const DisplayPage = (props) => {
  const { language } = useContext(LanguageContext);
  const classes = useStyles();
  const history = useHistory();

  const [isComparing, setIsComparing] = useState(false);

  const [comparedUnis, setComparedUnis] = useState([]);

  const [firstUniData, setFirstUniData] = useState([]);
  const [secondUniData, setSecondUniData] = useState([]);

  const [value, setValue] = useState(20);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const schools = localize("display.schools", language);

  const compare = (index, country) => {
    //console.log(comparedUnis)
    if (comparedUnis == false) {
      setIsComparing(true);
      setComparedUnis([schools[country][index].name, ""]);
      setFirstUniData([index, country]);
    } else if (comparedUnis[0] != false && comparedUnis[1] == false) {
      setComparedUnis([comparedUnis[0], schools[country][index].name]);
      setSecondUniData([index, country]);
    } else {
      setComparedUnis([schools[country][index].name, comparedUnis[0]]);
      setSecondUniData(firstUniData);
      setFirstUniData([index, country]);
    }
  };

  const runCompare = (firstUni, secondUni) => {
    const dataUnis = {
      firstUni: firstUniData,
      secondUni: secondUniData,
    };
    if (secondUni != false) {
      history.push({
        pathname: "/compare",
        state: { data: dataUnis },
      });
    }
  };

  let compareBottomBar;
  compareBottomBar = isComparing ? (
    <div className={classes.compareHeader}>
      <Typography className={classes.compareText}>
        {comparedUnis[0] + " VS " + comparedUnis[1]}
      </Typography>
      <Button
        onClick={() => {
          runCompare(comparedUnis[0], comparedUnis[1]);
        }}
        className={classes.runCompareButton}
      >
        <Typography>{localize("display.compare", language)}</Typography>
      </Button>
    </div>
  ) : (
    <div></div>
  );
  return (
    <div className={classes.root}>
      <CssBaseline />
      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <Toolbar />
        <Toolbar />
        <div className={classes.drawerContainer}>
          <List>
            <CustomTextField name="display.name">
              <SchoolIcon />
            </CustomTextField>
            <CustomTextField name="display.location">
              <ExploreIcon />
            </CustomTextField>
            <CustomTextField name="display.speciality">
              <FolderSpecialIcon />
            </CustomTextField>
          </List>
          <Divider />
          <List>
            <ListItem button>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <EuroIcon />
                </Grid>
                <Grid item xs={10}>
                  <Slider
                    value={value}
                    onChange={handleChange}
                    valueLabelDisplay="auto"
                    aria-labelledby="range-slider"
                    getAriaValueText={valuetext}
                  />
                </Grid>
              </Grid>
            </ListItem>

            <CustomTextField name="display.credits">
              <VerifiedUserIcon />
            </CustomTextField>
          </List>
        </div>
      </Drawer>
      <main className={classes.content}>
        {Object.keys(schools).map((country, index) => (
          <>
            <Typography
              variant="h5"
              style={{ padding: "5px", marginTop: "20px" }}
              key={`country-${index}`}
            >
              {country}
            </Typography>
            <div className={classes.accordionRoot}>
              {schools[country].map((school, index) => (
                <Accordion key={`accordion-${index}`}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.heading}>
                      {school.starred && (
                        <StarIcon style={{ paddingTop: 7, paddingRight: 7 }} />
                      )}
                      {!school.starred && (
                        <StarBorderIcon
                          style={{ paddingTop: 7, paddingRight: 7 }}
                        />
                      )}
                      {school.name}
                    </Typography>
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        compare(index, country);
                      }}
                      className={classes.compareButton}
                    >
                      <Typography>
                        {localize("display.compare", language)}
                      </Typography>
                    </Button>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container>
                      <Grid item xs={4}>
                        <List>
                          <ListItem>
                            <ListItemIcon>
                              <ExploreIcon />
                            </ListItemIcon>
                            <ListItemText primary={school.location} />
                          </ListItem>
                          <ListItem>
                            <ListItemIcon>
                              <FolderSpecialIcon />
                            </ListItemIcon>
                            <ListItemText
                              primary={school.specialities.join(", ")}
                            />
                          </ListItem>
                          <ListItem>
                            <ListItemIcon>
                              <EuroIcon />
                            </ListItemIcon>
                            <ListItemText primary={school.price} />
                          </ListItem>
                          <ListItem>
                            <ListItemIcon>
                              <VerifiedUserIcon />
                            </ListItemIcon>
                            <ListItemText primary={school.credits.join(", ")} />
                          </ListItem>
                          <ListItem>
                            <ListItemIcon>
                              <PeopleIcon />
                            </ListItemIcon>
                            <ListItemText primary={school.students} />
                          </ListItem>
                          <ListItem>
                            <ListItemIcon>
                              <TranslateIcon />
                            </ListItemIcon>
                            <ListItemText primary={school.level} />
                          </ListItem>
                        </List>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography variant="h6">
                          {localize("display.redTape", language)}
                        </Typography>
                        <Typography variant="body1" paragraph>
                          {school.redTape}
                        </Typography>
                        <Typography variant="h6">
                          {localize("display.friends", language)}
                        </Typography>
                        <Typography variant="body1">
                          <List>
                            {school.friends.map((friend, index) => (
                              <>
                                <ListItem>
                                  <ListItemAvatar>
                                    <Avatar
                                      alt={friend.name}
                                      src="/static/images/avatar/1.jpg"
                                    />
                                  </ListItemAvatar>
                                  <ListItemText primary={friend.name} />
                                </ListItem>
                              </>
                            ))}
                          </List>
                        </Typography>
                        <Typography variant="h6">
                          {localize("display.feedback", language)}
                        </Typography>
                        <Typography variant="body1">
                          <List className={classes.root}>
                            {school.comments.map((feedback, index) => (
                              <>
                                <ListItem alignItems="flex-start">
                                  <ListItemAvatar>
                                    <Avatar
                                      alt={feedback.name}
                                      src="/static/images/avatar/1.jpg"
                                    />
                                  </ListItemAvatar>
                                  <ListItemText primary={feedback.content} />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                              </>
                            ))}
                          </List>
                        </Typography>
                        <CenteredContent margin="4">
                          <Link
                            to="/"
                            style={{
                              textDecoration: "none",
                              color: "#504538",
                              display: "block",
                            }}
                          >
                            <Typography
                              align="center"
                              style={{
                                fontWeight: "bold",
                                backgroundColor: "#ffc26c",
                                padding: 10,
                                borderRadius: "100px",
                                textTransform: "uppercase",
                              }}
                            >
                              {localize("display.contact", language)}
                            </Typography>
                          </Link>
                        </CenteredContent>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              ))}
            </div>
          </>
        ))}
      </main>
      {compareBottomBar}
    </div>
  );
};

export default DisplayPage;
